import { render, staticRenderFns } from "./Tray.vue?vue&type=template&id=eaf0599a&"
import script from "./Tray.vue?vue&type=script&lang=js&"
export * from "./Tray.vue?vue&type=script&lang=js&"
import style0 from "./Tray.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports